// public/js/modules/filters/search-filter.js
export const searchFilter = {
    id: 'search',
    getDefaultState: () => ({ term: '' }),
  
    renderUI(state) {
      return `
        <div class="mb-3">
          <input type="text" id="filter-search" class="form-control tenant-blur"
                 placeholder="Search name, reference, type, status ..." value="${state.term}">
        </div>`;
    },

    apply(assets, state) {
      if (!state.term) return assets;
      const term = state.term.toLowerCase();
      // Search across the fields the asset model actually uses (V2: label /
      // reference / serial) plus type/status and the ids — i.e. everything the
      // user can see on a pin.
      return assets.filter(a => {
        const haystack = [
          a.label, a.name, a.reference, a.serial,
          a.type, a.status, a.assetId, a.assetUUID,
          a.tenantName
        ].filter(Boolean).join(' ').toLowerCase();
        return haystack.includes(term);
      });
    },
  
    attachListeners(container, manager) {
      const input = container.querySelector('#filter-search');
      let timeout;
      input.addEventListener('input', () => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          manager.updateFilter('search', { term: input.value.trim() });
        }, 250);
      });
    }
  };